import { Button } from "@/components/ui/button";
import { HeroImage } from "@/components/ui/hero-image";
import { ArrowRight, Heart, Shield, Users } from "lucide-react";

const Hero = () => {
  return (
    <HeroImage 
      src="/lovable-uploads/0142aa2a-76a4-4501-a11d-3d3b2db62312.png"
      alt="NearLab DNA Testing Services - Professional and Compassionate Testing"
      className="py-12 md:py-16 px-4"
    >
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 drop-shadow-lg animate-fade-in">
              Peace of Mind for Your Family, <br />
              <span className="bg-gradient-to-r from-white to-white/80 bg-clip-text text-transparent">
                Delivered with Care
              </span>
            </h1>
            
            <p className="text-lg mb-4 text-white/90 drop-shadow-md animate-fade-in leading-relaxed">We understand that DNA testing is deeply personal. That is why our certified professionals treat every family with compassion and respect, bringing professional AABB certified testing directly to you where you want.</p>
            
            <div className="flex items-center gap-4 mb-6 text-white/90">
              <div className="flex items-center gap-2">
                <Heart className="w-5 h-5 text-red-300" />
                <span className="text-sm">Compassionate Service</span>
              </div>
              <div className="flex items-center gap-2">
                <Shield className="w-5 h-5 text-blue-300" />
                <span className="text-sm">Complete Privacy</span>
              </div>
              <div className="flex items-center gap-2">
                <Users className="w-5 h-5 text-green-300" />
                <span className="text-sm">Family Focused</span>
              </div>
            </div>
            
            
            <div className="flex flex-col sm:flex-row gap-3 animate-fade-in">
              <Button 
                size="lg" 
                className="bg-white text-blue-primary hover:bg-white/90 font-bold px-6 py-3 shadow-xl transform hover:scale-105 transition-all duration-300 group" 
                onClick={() => window.location.href = '/booking'}
                aria-label="Schedule your DNA test appointment today"
              >
                Schedule Your Test Today
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-200" size={18} />
              </Button>
              <Button 
                size="lg" 
                className="bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white font-semibold border border-white/30 hover:border-white transition-all duration-300" 
                onClick={() => document.getElementById('services')?.scrollIntoView({
                  behavior: 'smooth'
                })}
                aria-label="Learn about our DNA testing process"
              >
                Learn About Our Process
              </Button>
            </div>
          </div>
          
        </div>
    </HeroImage>
  );
};
export default Hero;